import styled from 'styled-components';
import LLMPlayground from '../../LLMPlayground';
import { Label, NonCopyableMarkdown, SectionWrapper } from '../common';
import React from 'react';
import {
  AssessmentTestContext,
  AssessmentTestContextType,
} from '../../../contexts/assessment-test';
import FollowUp from './FollowUp';

const PlaygroundWrapper = styled.div`
  max-height: 80%;
  margin-top: 24px;
  padding-bottom: 12px;

  .llm-playground-wrapper {
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme.colors.bgActive};
    background-color: ${({ theme }) => theme.colors.bgDefaultSecondary};
  }

  .llm-playground-controls {
    padding: 10px 20px;
  }
`;

export default function LLMEditorSection({
  section,
  stepId,
}: {
  section: Extract<
    AssessmentTestContextType['steps'][number]['sections'][number],
    { type: 'llm-editor' }
  >;
  stepId: string;
}) {
  const [, dispatch] = React.useContext(AssessmentTestContext);

  const { content } = section;
  const prompt = section.answer;

  const onReset = () => {
    dispatch({
      type: 'CHANGE_ANSWER_LLM_EDITOR',
      payload: {
        stepId,
        sectionId: section.id,
        answer: section.initialPrompt,
      },
    });
  };

  const onPromptChange = (prompt: string) => {
    dispatch({
      type: 'CHANGE_ANSWER_LLM_EDITOR',
      payload: {
        stepId,
        sectionId: section.id,
        answer: prompt,
      },
    });
  };

  return (
    <SectionWrapper>
      <NonCopyableMarkdown md={content} />
      <PlaygroundWrapper>
        <LLMPlayground
          userPrompt={prompt}
          onPromptChange={onPromptChange}
          result={null}
          review={null}
          onSubmitPrompt={() => {}}
          onReset={onReset}
          isLoading={false}
          validationError={null}
          onPaste={(e) => {
            e.preventDefault();
            return false;
          }}
          isEditOnly
        />
      </PlaygroundWrapper>
      <Label>Write your answer in the prompt editor.</Label>
      <FollowUp section={section} stepId={stepId} />
    </SectionWrapper>
  );
}
